{
  "BlockType": {
    "article__attachment": "Bilaga",
    "article__audio": "Ljud",
    "article__bodytext": "Text",
    "article__byline": "Byline",
    "article__card": "Kort/informationsruta",
    "article__dateline": "Metadata",
    "article__media": "Bilder",
    "article__module": "Banner",
    "article__openinghours": "Öppettider",
    "article__person": "Person",
    "article__program": "Program",
    "article__quote": "Citat",
    "article__references": "Bibliografi",
    "article__relations": "Länksamling",
    "article__sharing": "Delning",
    "article__table": "Tabell",
    "article__title": "Titel",
    "article__video": "Video",
    "calendar": "Kalender (M24 1.0)",
    "calendar__navigator": "Tidsnavigator (M24 1.0)",
    "card": "Kort",
    "cardSearch": "Kortmodul",
    "digitaltMuseum": "DigitaltMuseum (M24 1.0)",
    "dm_auto": "Digitalt Museum (auto)",
    "dm_filter_search": "Utvidgad m/ filter",
    "dm_manual": "Digitalt Museum (manuell)",
    "dm_school": "Skola",
    "dm_single": "Digitalt Museum (enskild)",
    "employees_auto": "Anställda (automatisk)",
    "employees_manual": "Anställda (manuell)",
    "events_auto": "Evenemang (automatisk)",
    "events_manual": "Evenemang (manuell)",
    "flexible": "Widget",
    "form": "Formulär",
    "frontpage__module": "Banner",
    "kp": "KulturPunkt",
    "kp_owner": "KulturPunkt (museum)",
    "kulturpunkt": "KulturPunkt (M24 1.0)",
    "map": "Karta (M24 1.0)",
    "map_v2": "Karta",
    "member": "Medlemsuppgifter",
    "page_list_auto": "Automatisk sidlista",
    "page_list_manual": "Manuell sidlista",
    "productstatus": "Biljettförsäljning",
    "search": "Sökresultat",
    "ticket": "Onlinebiljett",
    "ticket_validation": "Biljettskanner",
    "timeline": "Tidslinje"
  },
  "DMContentType": {
    "Architecture": "Arkitektur",
    "Artdesign": "Konst/Design",
    "Article": "Artikel",
    "Audio": "Ljud",
    "Building": "Byggnad",
    "Construction": "Konstruktion",
    "Event": "Evenemang",
    "Exhibition": "Utställning",
    "Fineart": "Konstverk",
    "Folder": "Mapp",
    "Investigation": "Undersökning",
    "Media": "Media",
    "Museum": "Museum",
    "NavalVessel": "Marinfartyg",
    "Organization": "Organisation",
    "Person": "Person",
    "Photograph": "Fotografi",
    "School": "Skola (alla)",
    "school_digital": "Skola (digital)",
    "school_physical": "Skola (besök)",
    "Story": "Berättelse",
    "Thing": "Föremål",
    "TimePeriod": "Tidsperiod",
    "Video": "Video",
    "Virtual": "Virtuell upplevelse"
  },
  "DMSortTypes": {
    "artifact.ingress.title": "Titel",
    "artifact.publishedDate": "Publiceringsdatum",
    "artifact.updatedDate": "Datum för senaste uppdatering",
    "relevance": "Relevans",
    "score": "Relevans"
  },
  "Draggable": {
    "DropHereToAbort": "Släpp här för att avbryta",
    "MoveHere": "Flytta hit"
  },
  "FilterLabel": "Tillämpa filter på listan",
  "FilterOptions": {
    "created_by_id": "Uppladdad av mig",
    "missing_alt": "Saknar alternativtext",
    "none": "Inga filter"
  },
  "IntroSection": {
    "about": "Scrollytell-sektion används för enkla budskap ovanför växlande bakgrunder (mediaelement eller bakgrundsfärg (skin)). Växlande bakgrunder uppnås med minst två efterföljande scrollytell-sektioner.",
    "limitations": "OBS! Detta är en scrollytell-sektion. Inte alla moduler kan eller bör visas här. Vi rekommenderar att hålla sig till enkla textbudskap med hjälp av modulerna: text, citat och banners, så att bakgrundsmediat kommer till sin rätt. Växlande bakgrunder uppnås med minst två efterföljande scrollytell-sektioner."
  },
  "KulturioSchemaTypes": {
    "2": "KulturPunkt",
    "12": "Presentation",
    "13": "Kioskläge",
    "14": "Kioskenhet",
    "32": "Rebus"
  },
  "Languages": {
    "da": "Danska",
    "de": "Tyska",
    "en": "Engelska",
    "es": "Spanska",
    "fr": "Franska",
    "it": "Italienska",
    "ja": "Japanska",
    "ko": "Koreanska",
    "nl": "Nederländska",
    "nn": "Norsk nynorsk",
    "no": "Norska",
    "pl": "Polska",
    "ru": "Ryska",
    "se": "Nordsamiska",
    "sv": "Svenska",
    "zh": "Kinesiska"
  },
  "MainCategory": {
    "": "Ingen kategori",
    "current_affairs": "Aktuellt",
    "event": "Evenemang",
    "exhibition": "Utställning",
    "information": "Information",
    "knowledge": "Kunskap",
    "museum": "Museum/besöksmål",
    "system": "System"
  },
  "MainLanguageSite": "Huvudspråk i nettsidan",
  "MediaLicense": {
    "Description": {
      "AC 1": "Denna licens tillåter ingen återanvändning utan att upphovsmannen uttryckligen gett sitt tillstånd.",
      "CC by": "Denna licens tillåter användare att distribuera, remixa, anpassa och bygga vidare på materialet i valfritt medium eller format, så länge attribution ges till upphovsmannen. Licensen tillåter kommersiell användning.",
      "CC by-nc": "Denna licens tillåter användare att distribuera, remixa, anpassa och bygga vidare på materialet i valfritt medium eller format för icke-kommersiella ändamål endast, och endast så länge attribution ges till upphovsmannen.",
      "CC by-nc-nd": "Denna licens tillåter användare att kopiera och distribuera materialet i valfritt medium eller format i oanpassad form endast, för icke-kommersiella ändamål, och endast så länge attribution ges till upphovsmannen.",
      "CC by-nc-sa": "Denna licens tillåter användare att distribuera, remixa, anpassa och bygga vidare på materialet i valfritt medium eller format för icke-kommersiella ändamål, och endast så länge attribution ges till upphovsmannen. Om du remixar, anpassar eller bygger vidare på materialet måste du licensiera det ändrade materialet under samma villkor.",
      "CC by-nd": "Denna licens tillåter användare att kopiera och distribuera materialet i valfritt medium eller format i oanpassad form endast, och endast så länge attribution ges till upphovsmannen. Licensen tillåter kommersiell användning.",
      "CC by-sa": "Denna licens tillåter användare att distribuera, remixa, anpassa och bygga vidare på materialet i valfritt medium eller format, så länge attribution ges till upphovsmannen. Licensen tillåter kommersiell användning. Om du remixar, anpassar eller bygger vidare på materialet måste du licensiera det ändrade materialet under samma villkor.",
      "CC pdm": "Denna licens tillåter användare att distribuera, remixa, anpassa och bygga vidare på materialet i valfritt medium eller format, utan några villkor."
    },
    "FreeReuse": "Fri återanvändning",
    "Label": {
      "": "Ingen licens vald",
      "AC 1": "Upphovsrätt - Alla rättigheter förbehållna",
      "CC by": "Attribution",
      "CC by-nc": "Attribution, Icke-kommersiell",
      "CC by-nc-nd": "Attribution, Icke-kommersiell, Inga bearbetningar",
      "CC by-nc-sa": "Attribution, Icke-kommersiell, Dela lika",
      "CC by-nd": "Attribution, Inga bearbetningar",
      "CC by-sa": "Attribution, Dela lika",
      "CC pdm": "Ingen upphovsrätt"
    },
    "NoReuse": "Ingen återanvändning",
    "RestrictedReuse": "Begränsad återanvändning"
  },
  "MediaResourceType": {
    "asset": "Tillgångar",
    "audio": "Ljud",
    "card": "Kort",
    "document": "Dokument",
    "form": "Formulär",
    "gif": "Animationer",
    "image": "Bilder",
    "location": "Platser",
    "page": "Sidor",
    "person": "Personer",
    "video": "Videor"
  },
  "SaveType": {
    "delete_draft": "Radera utkast",
    "save": "$t(common:save)",
    "save_and_archive": "Spara och arkivera",
    "save_and_publish": "Spara och publicera",
    "save_and_unpublish": "Spara och avpublicera",
    "save_as_copy": "Spara som kopia",
    "save_as_new_template": "Kopiera till ny mall",
    "save_as_new_version": "Spara som ny version"
  },
  "SectionType": {
    "article__body": "Innehåll",
    "article__body_introSection": "Innehåll: Scrollytell-sektion",
    "article__head": "Titel och ingress",
    "article__links": "Kortsektion",
    "grid__row": "Rutnätssektion",
    "page__grid": "Sidlista"
  },
  "SortDirectionLabel": "Välj sorteringsordning",
  "SortDirections": {
    "asc": "Stigande",
    "date_asc": "Äldst först",
    "date_desc": "Nyast först",
    "desc": "Fallande",
    "text_asc": "A-Ö",
    "text_desc": "Ö-A"
  },
  "SortLabel": "Välj sorteringsmetod",
  "SortOptions": {
    "created_at_asc": "Skapad (äldst först)",
    "created_at_desc": "Skapad (nyast först)",
    "department_asc": "Avdelning (A-Ö)",
    "department_desc": "Avdelning (Ö-A)",
    "event_start_asc": "Evenemangsdatum, stigande",
    "event_start_desc": "Evenemangsdatum, fallande",
    "first_name_asc": "Förnamn (A-Ö)",
    "first_name_desc": "Förnamn (Ö-A)",
    "last_name_asc": "Efternamn (A-Ö)",
    "last_name_desc": "Efternamn (Ö-A)",
    "relevance_desc": "Relevans",
    "status_asc": "Status, stigande",
    "status_desc": "Status, fallande",
    "title_asc": "Titel (A-Ö)",
    "title_desc": "Titel (Ö-A)",
    "updated_at_asc": "Senast uppdaterad (äldst först)",
    "updated_at_desc": "Senast uppdaterad (nyast först)",
    "uploaded_at_asc": "Uppladdad (äldst först)",
    "uploaded_at_desc": "Uppladdad (nyast först)"
  },
  "SortTypeLabel": "Välj sorteringstyp",
  "SortTypes": {
    "created_at": "Skapad",
    "department": "Avdelning",
    "first_name": "Förnamn",
    "last_name": "Efternamn",
    "published_at": "Publicerad",
    "title": "Titel",
    "updated_at": "Senast uppdaterad",
    "uploaded_at": "Uppladdad"
  },
  "Statistics": "Statistik",
  "StatisticsIntro": "Standardstatistik för slutanvändare för denna webbplats. Levereras av Plausible (utan användning av cookies).",
  "Status": {
    "archived": "Arkiverad",
    "draft": "Utkast",
    "general": "Allmän",
    "hide_past_events": "Dölj tidigare evenemang",
    "imported": "Importerad",
    "include_past_events": "Tidigare evenemang",
    "no_draft": "Inget utkast",
    "not_published": "Inte publicerad",
    "published": "Publicerad",
    "published_not_listed": "Publicerad (olistad)",
    "planned_publishing": "Planerad publicering"
  },
  "SubCategory": {
    "activity": "Aktivitet",
    "adults": "Vuxna",
    "collection": "Samling",
    "concert": "Konsert",
    "conference": "Seminarium/Konferens",
    "course": "Kurs/workshop",
    "current_affairs": "Aktuellt",
    "digital": "Digital",
    "digital_event": "Digitalt evenemang",
    "earlier": "Tidigare",
    "exhibition": "Utställning",
    "family": "Familj",
    "family_event": "Familjeevenemang",
    "kids": "Barn",
    "lecture": "Föreläsning/Samtal",
    "market": "Marknad",
    "museum": "Museum/besöksmål",
    "open_position": "Ledig tjänst",
    "opening": "Invigning",
    "performance": "Föreställning",
    "permanent": "Permanent",
    "press": "Press",
    "recurring_event": "Återkommande evenemang",
    "recurring_program": "Återkommande program",
    "rental": "Uthyrning",
    "research": "Forskning",
    "school": "Skola",
    "school_event": "Skolevenemang",
    "services": "Tjänster",
    "temporary": "Tillfällig",
    "touring": "Vandringsutställning",
    "tour": "Visning",
    "upcoming": "Kommande",
    "youth": "Unga"
  },
  "ViewType": {
    "grid": "Rutnätsvy",
    "list": "Listvy"
  },
  "WeekDay": {
    "fri": "Fredag",
    "mon": "Måndag",
    "sat": "Lördag",
    "sun": "Söndag",
    "thu": "Torsdag",
    "tue": "Tisdag",
    "wed": "Onsdag"
  },
  "abort": "Avbryt",
  "add": "Lägg till",
  "addX": "Lägg till {{x}}",
  "all": "Alla",
  "appName": "Museum24 - Admin",
  "approved": "Godkänd",
  "auto": "Auto",
  "cancel": "Avbryt",
  "changeItemSize": "Ändra objektets storlek",
  "clear": "Rensa",
  "close": "Stäng",
  "copy": "Kopiera",
  "createdAt": "Skapad den",
  "cut": "Klipp ut",
  "date": "Datum",
  "decline": "Avvisa",
  "declined": "Avvisad",
  "default": "Standard",
  "delete": "Radera",
  "deleteFailed": "Ett fel uppstod vid radering",
  "deleteSuccess": "Raderat utan problem",
  "deleteWarning": "Är du säker på att du vill radera objektet?",
  "description": "Beskrivning",
  "done": "Klar",
  "duplicate": "Duplicera",
  "error": "Ett fel uppstod",
  "eventData": "Evenemangsdata",
  "exit": "Avsluta",
  "exitUnsavedWarning": "Är du säker på att du vill avsluta? Du har osparade ändringar.",
  "from": "Från",
  "hide": "Dölj",
  "hidden": "Dold",
  "icon": "Ikon",
  "ifOtherThanX": "Om annan än \"{{x}}\"",
  "inputLabel": "Etikett",
  "internalDescription": "Intern beskrivning",
  "language": "Språk",
  "lastEdited": "Senast redigerad",
  "loading": "Laddar...",
  "loadingContent": "Laddar innehåll...",
  "menu": "Meny",
  "metadata": "Metadata",
  "moveDown": "Flytta ned",
  "moveUp": "Flytta upp",
  "name": "Namn",
  "no": "Nej",
  "noContent": "Inget innehåll",
  "none": "Ingen",
  "noneSelected": "Inget valt",
  "ok": "Ok",
  "others": "Övriga",
  "owner": "Ägare",
  "pasteName": "Klistra in {{name}}",
  "pending": "Avvaktar",
  "place": "Plats",
  "publishDate": "Publiceringsdatum",
  "publishingStatus": "Publiceringsstatus",
  "remove": "Ta bort",
  "removeX": "Ta bort {{x}}",
  "removed": "Borttagen",
  "required": "Obligatorisk",
  "save": "Spara",
  "saveAndExit": "Spara och avsluta",
  "saveFailed": "Ett fel uppstod vid sparning",
  "saveSuccess": "Sparat utan problem",
  "saved": "Sparat!",
  "screenshotInstructionErrorMessage": "Ta en skärmdump av hela fönstret, inklusive detta felmeddelande, om du ska rapportera felet",
  "search": "Sök...",
  "searchAndKeywords": "Sök och nyckelord...",
  "searchAndCategories": "Sök och kategorier...",
  "selectAll": "Markera alla",
  "selectFromList": "Välj från listan",
  "settings": "Inställningar",
  "show": "Visa",
  "ShowMore": "Visa mer",
  "showTitle": "Visa titel",
  "showPortal": "Öppna portal/sida",
  "showPortalDesign": "Öppna portalens designöversikt",
  "showingXofY": "Visar {{x}} av {{y}}",
  "siteChanged": "Ändrad webbplats",
  "status": "Status",
  "template": "Mall",
  "title": "Titel",
  "to": "Till",
  "tryAgain": "Försök igen",
  "unselectAll": "Avmarkera alla",
  "updatedAt": "Uppdaterad den",
  "userIcon": {
    "alert": "Varning",
    "date": "Kalender",
    "download": "Hämta",
    "email": "E-post",
    "eye": "Öga",
    "info": "Information",
    "person": "Person",
    "phone": "Telefon",
    "place": "Plats",
    "ticket": "Biljett",
    "time": "Klocka"
  },
  "validation": {
    "genericError": "Detta fält är ogiltigt",
    "max": "Värdet måste vara mindre än eller lika med {{max}}",
    "maxLength": "För många tecken",
    "min": "Värdet måste vara större än eller lika med {{min}}",
    "minLength": "För få tecken",
    "pattern": "Ogiltigt format",
    "required": "Detta fält är obligatoriskt"
  },
  "yes": "Ja"
}
